import React, { useContext } from 'react';
import { LegalDocumentsContext } from '../contexts/LegalDocumentsContext';

/**
 * @typedef {object} DownloadFileProps
 * @property {Object} [document]
 * @property {string} [text]
 */

/**
 * @param {DownloadFileProps} props
 */
export const DownloadFile = props => {
  const { document, text } = props;
  const { downloadFile } = useContext(LegalDocumentsContext);

  const handleFileDownload = async (event, record) => {
    event.preventDefault();
    await downloadFile(record.id);
  };

  return <a onClick={e => handleFileDownload(e, document)}>{text}</a>;
};

export default DownloadFile;
